import React, { useState, useRef, useEffect } from 'react';
import { Text } from '../../../../../components/textVariations';
import { Icon } from '../../../../../utilities/icomoon-css';
import { UnitAvailabilityTypes } from '../UnitAvailabilityTypes';
import { MAIN_FILTER_HEADING } from './constants/viewRatesFilterConfig';
import { useWindowDimensions } from '../../../../../utilities/Dimensions';
import {
  mobilescreensize,
  tabletscreensize,
} from '../../../../../utilities/constants';
import { ViewRatesFilterModal } from './ViewRatesFilterModal';
import { FilterSection } from './helpers/ReusableFilterComponent';
import { weakKey } from '../../../../../utilities/weakKey';
import { onFilterChange } from './helpers/viewRatesFilterHelper';

export const ViewRatesFilter = ({
  unitsFilter,
  activeFilters,
  activeFilterStateHandler,
}: UnitAvailabilityTypes.TViewRatesFilter) => {
  const [filterStatus, setFilterStatus] = useState({
    showUnitTypeFilter: false,
    showAmenitiesTypeFilter: false,
  });
  const [unitsTypeFilterDivHeight, setUnitTypeFilterDivHeight] = useState(0);
  const [
    amenitiesTypeFilterDivHeight,
    setAmenitiesTypeFilterDivHeight,
  ] = useState(0);
  const [showViewRatesModal, setShowViewRatesModal] = useState(false);

  const parentFilterSectionRef = useRef<any>();
  const unitsTypeFilterRef = useRef<any>();
  const amenitiesTypeFilterRef = useRef<any>();
  const amenitiesSectionRef = useRef<any>();
  const unitsTypeSectionRef = useRef<any>();
  const tagSectionRef = useRef<any>();

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (unitsTypeFilterRef.current || amenitiesTypeFilterRef.current) {
      setUnitTypeFilterDivHeight(unitsTypeFilterRef.current.clientHeight);
      setAmenitiesTypeFilterDivHeight(
        amenitiesTypeFilterRef.current.clientHeight
      );
    }

    if (showViewRatesModal && width <= tabletscreensize) {
      const scrollY = window.scrollY;
      document.body.style.overflowY = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${scrollY}px`;
    } else if (!showViewRatesModal && width <= tabletscreensize) {
      const scrollY = document.body.style.top;
      document.body.style.overflowY = '';
      document.body.style.position = 'static';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    return () => {
      document.body.style.overflowY = '';
      document.body.style.position = 'static';
    };
  }, [showViewRatesModal]);

  const handleClickOutside = (e: any) => {
    const notClickedOnAmenitiesSection =
      amenitiesSectionRef.current &&
      !amenitiesSectionRef.current.contains(e.target);
    const notClickedOnUnitsTypeSection =
      unitsTypeSectionRef.current &&
      !unitsTypeSectionRef.current.contains(e.target);
    if (
      notClickedOnAmenitiesSection &&
      !unitsTypeSectionRef.current.contains(e.target) &&
      !tagSectionRef.current.contains(e.target)
    ) {
      setFilterStatus(prevState => ({
        ...prevState,
        showAmenitiesTypeFilter: false,
      }));
    }
    if (
      notClickedOnUnitsTypeSection &&
      !amenitiesSectionRef.current.contains(e.target) &&
      !tagSectionRef.current.contains(e.target)
    ) {
      setFilterStatus(prevState => ({
        ...prevState,
        showUnitTypeFilter: false,
      }));
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, []);

  const changeFilterDropDownStatus = (filterType: string) => {
    if (filterType === 'amenities') {
      setFilterStatus(prevState => ({
        ...prevState,
        showAmenitiesTypeFilter: !prevState.showAmenitiesTypeFilter,
      }));
    } else {
      setFilterStatus(prevState => ({
        ...prevState,
        showUnitTypeFilter: !prevState.showUnitTypeFilter,
      }));
    }
  };

  const openResponsiveFilterHandler = () => {
    setShowViewRatesModal(!showViewRatesModal);
  };

  const ActiveFilterTags = () => {
    return (
      <div className="activeFilterTagsSection">
        {activeFilters.map((indivFilter: any) => (
          <>
            {indivFilter.name !== 'All' && (
              <span
                className="tags is-rounded indivTag"
                key={weakKey({ indivFilter })}
              >
                <Text renderAs={'p'}>{indivFilter.value}</Text>
                <button
                  onClick={() =>
                    onFilterChange(
                      indivFilter,
                      activeFilters,
                      activeFilterStateHandler,
                      unitsFilter
                    )
                  }
                >
                  <Icon name="tfw-close-circle-cp" />
                </button>
              </span>
            )}
          </>
        ))}
      </div>
    );
  };

  const ViewRatesDesktopFilter = () => (
    <>
      <h5 className="pb-3">{MAIN_FILTER_HEADING}</h5>
      <div className="viewRatesFilterSection">
        <FilterSection
          currentStatus={filterStatus.showAmenitiesTypeFilter}
          filterType={'amenities'}
          heightForTop={amenitiesTypeFilterDivHeight}
          activeFilters={activeFilters}
          activeFilterStateHandler={activeFilterStateHandler}
          changeFilterDropDownStatus={changeFilterDropDownStatus}
          divRef={amenitiesSectionRef}
          filterRef={amenitiesTypeFilterRef}
          unitsFilter={unitsFilter}
        />
        <FilterSection
          currentStatus={filterStatus.showUnitTypeFilter}
          filterType={'unitsType'}
          heightForTop={unitsTypeFilterDivHeight}
          activeFilters={activeFilters}
          activeFilterStateHandler={activeFilterStateHandler}
          changeFilterDropDownStatus={changeFilterDropDownStatus}
          divRef={unitsTypeSectionRef}
          filterRef={unitsTypeFilterRef}
          unitsFilter={unitsFilter}
        />
      </div>
      <div className="tagsSection" ref={tagSectionRef}>
        {activeFilters && activeFilters.length > 0 && <ActiveFilterTags />}
      </div>
    </>
  );

  const ViewRatesSmallScreenFilter = () => (
    <div className="viewRatesSmallScreenSection">
      <div className="dropdownSection" onClick={openResponsiveFilterHandler}>
        <Icon name="tfw-filter-2-cp" />
        <h5 className="pb-3">{MAIN_FILTER_HEADING}</h5>
      </div>
      {showViewRatesModal && (
        <ViewRatesFilterModal
          openResponsiveFilterHandler={openResponsiveFilterHandler}
          activeFilters={activeFilters}
          unitsFilter={unitsFilter}
          amenitiesTypeFilterDivHeight={amenitiesTypeFilterDivHeight}
          unitsTypeFilterDivHeight={unitsTypeFilterDivHeight}
          activeFilterStateHandler={activeFilterStateHandler}
        />
      )}
    </div>
  );

  return (
    <div className="viewRatesParentFilterSection" ref={parentFilterSectionRef}>
      {width > mobilescreensize ? (
        <ViewRatesDesktopFilter />
      ) : (
        <ViewRatesSmallScreenFilter />
      )}
    </div>
  );
};
